import type { NavThemeTokens } from './nav-tokens';
import { navRowClass } from './navRowClass';

/** Shared geometry for a top-level section row, so the navigable, expandable
 *  and inert variants line up with each other in both the drawer and the
 *  labelled panel. */
export const SECTION_ROW =
  'flex h-11 w-full items-center gap-3 rounded-[10px] border-0 bg-transparent px-3 text-[15px] font-bold no-underline';

/** The same row in the icon rail, where it has to match the 40px box every
 *  other rail control keeps or its glyph sits off the column's line. */
export function sectionRowClass(collapsed: boolean): string {
  return collapsed ? navRowClass('panel-collapsed') : SECTION_ROW;
}

/** A section row's colours. The section you are in and the section whose
 *  fly-out is open read the same — both are "the one you are looking at". */
export function sectionTone(
  t: NavThemeTokens,
  lit: boolean,
): { background?: string; color: string } {
  return lit ? { background: t.cream, color: t.barkDark } : { color: t.ink };
}
